var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":_vm.$t('pages.about') + ' - Fernando Mata'}}),_c('article',{staticClass:"post"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('about.info'))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }